import { jsx, jsxs } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { DataProvider } from "./RentVsBuyDataProvider.esm.js";
import ChartContent from "./components/ChartContent/ChartContent.esm.js";
import CustomScrollSection from "./components/CustomScrollSection/CustomScrollSection.esm.js";
const contentLayout = css({
  display: "grid",
  gap: "sm",
  marginTop: "token(spacing.400)",
  gridTemplateColumns: {
    base: "1fr",
    md: "5fr 3fr"
  }
});
const columnMin = css({
  minWidth: "0"
});
const toFiniteFloat = (s) => {
  if (s === void 0) return void 0;
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : void 0;
};
const RentVsBuyCalculator = ({
  purchasePrice,
  downPaymentPercent,
  monthlyRent,
  mortgageRate
}) => {
  return /* @__PURE__ */ jsx("div", { className: contentLayout, children: /* @__PURE__ */ jsxs(DataProvider, { initialPurchasePrice: toFiniteFloat(purchasePrice), initialDownPaymentPercent: toFiniteFloat(downPaymentPercent), initialMonthlyRent: toFiniteFloat(monthlyRent), initialMortgageRate: toFiniteFloat(mortgageRate), children: [
    /* @__PURE__ */ jsx("div", { className: columnMin, children: /* @__PURE__ */ jsx(ChartContent, {}) }),
    /* @__PURE__ */ jsx("div", { className: columnMin, children: /* @__PURE__ */ jsx(CustomScrollSection, {}) })
  ] }) });
};
export {
  RentVsBuyCalculator as default
};
